import { Field, FieldProps } from "formik"
import React from "react"

import styles from "./index.module.css"

type Props = {
  label: string
  name: string
  value?: string
}

export const FormRadio: React.FC<Props> = ({ label, name, value }) => (
  <Field name={name} type="radio" value={value}>
    {({ field }: FieldProps) => {
      return (
        <div className={styles.Wrapper}>
          <input {...field} id={label} type="radio" />
          <label htmlFor={label}>{label}</label>
        </div>
      )
    }}
  </Field>
)
